import { OrgApiError } from "@/services/orgApiFetch";

export function isAmbiguousIssuanceError(error: unknown): boolean {
    return !(error instanceof OrgApiError);
}

export function isCurrentClientApiContext(operationContextUuid: string, currentContextUuid: string | null): boolean {
    return operationContextUuid === currentContextUuid;
}
